// Tenant config — lit toutes les variables VITE_TENANT_* injectées par Vite.
// Aucun fallback hardcodé "Herbo" : si la var manque, on tombe sur un placeholder neutre
// pour qu'un déploiement mal configuré soit visible immédiatement.

export interface TenantConfig {
  readonly id: string;
  readonly name: string;
  readonly shortName: string;
  readonly accent: string;
  readonly logoUrl: string | null;
}

const env = import.meta.env;

function readEnv(key: string, fallback: string): string {
  const v = env[key];
  return typeof v === 'string' && v.length > 0 ? v : fallback;
}

export const tenant: TenantConfig = {
  id: readEnv('VITE_TENANT_ID', 'unknown-tenant'),
  name: readEnv('VITE_TENANT_NAME', 'Tenant non configuré'),
  shortName: readEnv('VITE_TENANT_SHORT_NAME', 'AIOS'),
  accent: readEnv('VITE_TENANT_ACCENT', '#059669'),
  logoUrl: env.VITE_TENANT_LOGO_URL ? String(env.VITE_TENANT_LOGO_URL) : null,
};

export const chatbotApiBase = readEnv('VITE_CHATBOT_API_BASE', 'http://localhost:4321');
export const apiBaseUrl = readEnv('VITE_API_BASE_URL', '/api');

/**
 * Applique l'accent du tenant en CSS custom property sur :root.
 * Appelé une fois au boot — permet aux modules de référencer var(--accent).
 */
export function applyTenantTheme(): void {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  root.style.setProperty('--accent', tenant.accent);
  root.dataset.tenant = tenant.id;
}
